import axios from "axios";
import queryString from "query-string";
import loadConfig from "../apiService";
import { decryptToken, encryptToken } from "./EncryptionToken";
import { jwtDecode } from "jwt-decode";
import { useCookies } from "react-cookie";

const LogInManagerServices = async () => {
  let config = await loadConfig();
  let userToken = "";
  
  function getCookieValue(cookieName) {
    const cookies = document.cookie.split("; ");
    //console.log(cookies, "cookies");

    for (let i = 0; i < cookies.length; i++) {
      const [name, value] = cookies[i].split("=");
      if (name === cookieName) {
        return value;
      }
    }
    return null; // إذا لم يتم العثور على الكوكي
  }
  const username = getCookieValue("loginTokenSSO");

  //console.log(username, "cookies.loginTokenSSO"); // يعرض قيمة الكوكي "username"

  try {
    // Check if tokens are stored in sessionStorage instead of cookies
    if (
      !sessionStorage.getItem("RefreshtokenManager") &&
      !sessionStorage.getItem("AccessTokenManager") &&
      username
    ) {
      //console.log(username, "11111111111111111111"); // يعرض قيمة الكوكي "username"

      // Perform login on your backend
      const loginResult = await axios.post(
        `${config.domainUrl}/api/Account/Login`,
        {
          nameSso: "internal",
          token: username,
        }
      );
      //console.log(loginResult, "loginResult");

      // Store tokens in sessionStorage instead of cookies
      var userInfo = jwtDecode(loginResult.data.result.refreshToken);
      //     dispatch(SetDataUser(userInfo))
      var refreshToken = encryptToken(loginResult.data.result.refreshToken);
      var AccessToken = encryptToken(loginResult.data.result.accessToke);
      sessionStorage.setItem("RefreshtokenManager", refreshToken);
      sessionStorage.setItem("AccessTokenManager", AccessToken);
      userToken = userInfo;
      

      window.location.replace(config.redirect_uri+"manager/RequestsManager/");
    } else if (
      sessionStorage.getItem("RefreshtokenManager") &&
      sessionStorage.getItem("AccessTokenManager")&&username
    ) {
      userToken = jwtDecode(decryptToken("AccessTokenManager","manager"));
     
    } else {
      window.location.replace(config.internalSsoUrlreturn);
    
    }
  } catch (err) {
    //console.log("catch", err);
  }
  return {userToken:userToken,login:"manager"};
};

export default LogInManagerServices;
